var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", [_c("comp-search-box", {
    attrs: {
      loginTimedata: _vm.loginTimedata,
      payInfoData: _vm.payInfoData,
      coinInfoData: _vm.coinInfoData,
      stageInfoData: _vm.stageInfoData,
      taskInfoData: _vm.taskInfoData,
      activeName: _vm.activeName
    },
    on: {
      compBtnSearch: _vm.compBtnSearch
    }
  })], 1), _c("div", [[_c("el-tabs", {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_c("el-tab-pane", {
    attrs: {
      label: "玩家信息",
      name: "roleMsg"
    }
  }, [_c("div", [_c("comp-role-info", {
    ref: "roleChild",
    attrs: {
      serverList: _vm.serverList
    }
  })], 1)]), _c("el-tab-pane", {
    attrs: {
      label: "角色登录日志",
      name: "loginMsg"
    }
  }, [[_vm._v(" 选择日期： "), _c("time-date-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.loginTimedata,
      callback: function callback($$v) {
        _vm.loginTimedata = $$v;
      },
      expression: "loginTimedata"
    }
  })], _c("div", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c("comp-role-login", {
    ref: "loginChild",
    attrs: {
      serverList: _vm.serverList
    }
  })], 1)], 2), _c("el-tab-pane", {
    attrs: {
      label: "充值日志",
      name: "payMsg"
    }
  }, [[_vm._v(" 选择日期： "), _c("time-date-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.payInfoData.payTimedata,
      callback: function callback($$v) {
        _vm.$set(_vm.payInfoData, "payTimedata", $$v);
      },
      expression: "payInfoData.payTimedata"
    }
  }), _vm._v(" 选择订单状态： "), _c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.payInfoData.status,
      callback: function callback($$v) {
        _vm.$set(_vm.payInfoData, "status", $$v);
      },
      expression: "payInfoData.status"
    }
  }, _vm._l(_vm.orderStatus, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _vm._v(" 游戏订单号： "), _c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.payInfoData.cp_orderno,
      callback: function callback($$v) {
        _vm.$set(_vm.payInfoData, "cp_orderno", $$v);
      },
      expression: "payInfoData.cp_orderno"
    }
  }), _vm._v(" 平台订单号： "), _c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.payInfoData.platform_orderno,
      callback: function callback($$v) {
        _vm.$set(_vm.payInfoData, "platform_orderno", $$v);
      },
      expression: "payInfoData.platform_orderno"
    }
  })], _c("div", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c("comp-pay", {
    ref: "payChild",
    attrs: {
      serverList: _vm.serverList
    }
  })], 1)], 2), _c("el-tab-pane", {
    attrs: {
      label: "货币日志",
      name: "coinMsg"
    }
  }, [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "选择日期：",
      "label-width": "120px"
    }
  }, [_c("time-date-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.coinInfoData.coinTimedata,
      callback: function callback($$v) {
        _vm.$set(_vm.coinInfoData, "coinTimedata", $$v);
      },
      expression: "coinInfoData.coinTimedata"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "变更类型：",
      "label-width": "120px"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.coinInfoData.changeType,
      callback: function callback($$v) {
        _vm.$set(_vm.coinInfoData, "changeType", $$v);
      },
      expression: "coinInfoData.changeType"
    }
  }, _vm._l(_vm.changeTypeOption, function (item) {
    return _c("el-option", {
      key: item.ID,
      attrs: {
        label: item.val,
        value: item.ID
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "货币类型：",
      "label-width": "150px"
    }
  }, [_c("CoinSelect", {
    attrs: {
      coinTypeLists: _vm.coinTypeLists
    },
    model: {
      value: _vm.coinInfoData.coin_type,
      callback: function callback($$v) {
        _vm.$set(_vm.coinInfoData, "coin_type", $$v);
      },
      expression: "coinInfoData.coin_type"
    }
  })], 1)], 1), _c("div", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c("comp-coin", {
    ref: "coinChild",
    attrs: {
      reasonList: _vm.reasonList,
      coinList: _vm.coinList,
      serverList: _vm.serverList
    }
  })], 1)], 1), _c("el-tab-pane", {
    attrs: {
      label: "道具日志",
      name: "stageMsg"
    }
  }, [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "选择日期：",
      "label-width": "120px"
    }
  }, [_c("time-date-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.stageInfoData.stageTimedata,
      callback: function callback($$v) {
        _vm.$set(_vm.stageInfoData, "stageTimedata", $$v);
      },
      expression: "stageInfoData.stageTimedata"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "道具ID/Name：",
      "label-width": "120px"
    }
  }, [_c("goods-options", {
    attrs: {
      type: 2,
      goodsArray: _vm.goodsArray
    },
    model: {
      value: _vm.stageInfoData.goods_id,
      callback: function callback($$v) {
        _vm.$set(_vm.stageInfoData, "goods_id", $$v);
      },
      expression: "stageInfoData.goods_id"
    }
  })], 1)], 1), _c("div", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c("comp-stage", {
    ref: "stageChild",
    attrs: {
      goodsList: _vm.goodsList,
      reasonList: _vm.reasonList,
      serverList: _vm.serverList
    }
  })], 1)], 1), _c("el-tab-pane", {
    attrs: {
      label: "任务日志",
      name: "taskMsg"
    }
  }, [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "选择日期：",
      "label-width": "120px"
    }
  }, [_c("time-date-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.taskInfoData.taskTimedata,
      callback: function callback($$v) {
        _vm.$set(_vm.taskInfoData, "taskTimedata", $$v);
      },
      expression: "taskInfoData.taskTimedata"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "任务ID/Name：",
      "label-width": "120px"
    }
  }, [_c("task-options", {
    model: {
      value: _vm.taskInfoData.task_id,
      callback: function callback($$v) {
        _vm.$set(_vm.taskInfoData, "task_id", $$v);
      },
      expression: "taskInfoData.task_id"
    }
  })], 1)], 1), _c("div", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c("comp-main-task", {
    ref: "taskChild",
    attrs: {
      serverList: _vm.serverList
    }
  })], 1)], 1)], 1)]], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };